<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <div class="row m-0 formborder">
    <div class="col-md-3 mt-3">
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input
              type="text"
              id="FilterInputSearch"
              (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch"
              placeholder="What're you searching for?"
              class="form-control border-0 bg-light"
            />
            <div class="input-group-append">
              <button
                id="button-addon1"
                type="submit"
                class="btn btn-link text-primary"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- <div class="col-md-3 p-1">
      <select
        name="FilterStatusId"
        id="FilterStatusId"
        style="display: none"
        class="form-control input-text-css"
        (change)="changeFilter()"
        [(ngModel)]="status"
      >
        <option value="Active">Active</option>
        <option value="Deactive">Deactive</option>
      </select>
    </div> -->
    <!-- <div class="col-md-6 p-1 text-right">
      <button
        class="mt-3 btn font-size-12 button-btn"
        (click)="OnOpenProductModal()"
      >
        New Product
      </button>
    </div> -->
  </div>
  <div class="table-responsive mt-3">
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="ProductId">
        <mat-header-cell
          mat-sort-header
          class="grid-header"
          style="max-width: 40px"
          *matHeaderCellDef
        >
          #
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row; let i = index"
          class="grid-cell"
          style="max-width: 40px; max-height: 5px"
        >
          {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Category">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          Product Category
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Category }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Product">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          Product
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Product }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ShortName">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          Short Name
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.ShortName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="CRC">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          CRC
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.CRC }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="FI">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          FI
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.FI }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="TVR">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          TVR
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.TVR }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="MultipleTranche">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          Multiple Tranche
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.MultipleTranche }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Insurance">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          Insurancee
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Insurance }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="CustomerReference">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          Reference
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.CustomerReference }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="NACHPDC">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          NACH-PDC
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.NACHPDC }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ActiveStatus">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          Active Status
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          <div
            *ngIf="row.Product_IsActive == true"
            style="width: 100%; color: #02e47c"
          >
            {{ row.ActiveStatus }}
          </div>
          <div
            *ngIf="row.Product_IsActive == false"
            style="width: 100%; color: orangered"
          >
            {{ row.ActiveStatus }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="EditAction">
        <mat-header-cell
          mat-sort-header
          class="grid-header"
          style="max-width: 100px"
          *matHeaderCellDef
        >
          Action
        </mat-header-cell>
        <mat-cell
          *matCellDef="let row"
          class="grid-cell"
          style="max-width: 100px"
        >
          <!-- <i
            class="fa fa-trash style-delete"
            (click)="onDeleteProduct(row)"
            style="cursor: pointer"
            aria-label="true"
          ></i> -->
          <i
            class="fa fa-arrow-circle-right arrow-circle action-btn"
            (click)="goToProductDetail(row)"
            style="margin-left: 16px"
            aria-label="true"
          ></i>
        </mat-cell>
      </ng-container>
      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator
      #paginatorRef
      [pageSizeOptions]="[20, 50]"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
</div>
